import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";

const CustomerAuthContext = createContext();
export const useCustomerAuth = () => useContext(CustomerAuthContext);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null=loading, false=guest, obj=logged
  const { mergeAccountCart, repriceCart } = useCart();

  useEffect(() => {
    if (!localStorage.getItem("aj_customer_token")) { setCustomer(false); return; }
    api.get("/shop/auth/me").then((r) => { setCustomer(r.data); repriceCart(); }).catch(() => { localStorage.removeItem("aj_customer_token"); setCustomer(false); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const afterAuth = async (data) => {
    localStorage.setItem("aj_customer_token", data.token);
    setCustomer(data.customer);
    await mergeAccountCart();
  };

  const register = async (payload) => { const { data } = await api.post("/shop/auth/register", payload); await afterAuth(data); };
  const login = async (payload) => { const { data } = await api.post("/shop/auth/login", payload); await afterAuth(data); };
  const logout = () => { localStorage.removeItem("aj_customer_token"); setCustomer(false); };

  return (
    <CustomerAuthContext.Provider value={{ customer, register, login, logout }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}
